import { dispatch, stateRef } from './store'
import type { CommonStoreState, ActivationData, TSGDisplayType, ActivationInstance } from './store'
export type Action = {
  type: 'update-props'
  props?: Partial<CommonStoreState>
} | {
  type: 'update-activation-data'
  data: Partial<ActivationData>
} | {
  type: 'update-activation-instances'
  instances: Record<string, ActivationInstance | undefined>
}

/**
 * Set values to the top level of global state using object shallow merge
 * @param props - partial of the global state needs to be merged
 */
export const updateStateProps = (props: Partial<CommonStoreState>) => {
  dispatch({ type: 'update-props', props })
}

export const updateActivationData = (data: Partial<ActivationData>) => {
  dispatch({ type: 'update-activation-data', data })
}

export const updateActivationInstances = (instances: Record<string, ActivationInstance | undefined>) => {
  dispatch({ type: 'update-activation-instances', instances })
}

export const updateTSGDisplayType = (tsgDisplayType: TSGDisplayType) => {
  updateStateProps({ tsgDisplayType })
}

export const setScreen = (key: string) => {
  const { manifest } = stateRef.current
  const nextScreen = manifest?.activation_screens.find(screen => screen.key === key)
  updateStateProps({ screen: nextScreen })
}

export const passDownActions = {
  updateActivationData,
  updateTSGDisplayType,
  updateActivationInstances,
}

export type Actions = typeof passDownActions
